import React from "react";
import { Menu, FileText, Home, ChevronLeft } from "lucide-react";

const MobileCourseButtons = ({
  showOverview,
  activeModule,
  activePage,
  showModulePages,
  setIsMobileMenuOpen,
  setIsPagesMenuOpen,
  onShowOverview,
  onBackToModules
}) => {
  // Показываем кнопку модулей когда:
  // 1. На обзоре курса
  // 2. Просматриваем список уроков модуля
  // 3. Просматриваем конкретный урок
  const showModulesButton = showOverview || showModulePages || (activeModule && activePage);

  // Показываем кнопку уроков когда:
  // 1. Выбран модуль и смотрим конкретный урок
  // 2. НЕ на странице списка уроков модуля
  const showPagesButton = activeModule && activePage && !showModulePages;

  const getTabs = () => {
    const tabs = [];

    // Таб "Главная" - всегда показываем если не на обзоре
    if (!showOverview) {
      tabs.push({
        id: 'overview',
        label: 'Главная',
        icon: Home,
        active: false,
        onClick: onShowOverview
      });
    }

    // Таб "Модули" - показываем когда есть активные модули
    if (showModulesButton) {
      tabs.push({
        id: 'modules',
        label: 'Модули',
        icon: Menu,
        active: showOverview || showModulePages,
        onClick: () => {
          if (showModulePages || showOverview) return;
          setIsMobileMenuOpen(true);
        }
      });
    }

    // Таб "Назад к урокам" - когда смотрим конкретный урок
    if (showModulePages && activeModule) {
      tabs.push({
        id: 'back',
        label: 'К урокам',
        icon: ChevronLeft,
        active: false,
        onClick: onBackToModules
      });
    }

    // Таб "Уроки" - когда смотрим конкретный урок
    if (showPagesButton) {
      tabs.push({
        id: 'pages',
        label: 'Уроки',
        icon: FileText,
        active: false,
        onClick: () => setIsPagesMenuOpen(true)
      });
    }

    return tabs;
  };

  const tabs = getTabs();
  if (tabs.length === 0) return null;

  return (
    <div className="lg:hidden w-full">
      {/* Мобильная навигация табов */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="flex items-center justify-center px-0 py-3">
          <div className="flex bg-gray-100 rounded-lg p-1 w-full">
            {tabs.map((tab) => {
              const IconComponent = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={tab.onClick}
                  className={`flex-1 flex items-center justify-center space-x-1 px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 whitespace-nowrap
                    ${tab.active ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'}`}
                >
                  <IconComponent className="w-4 h-4 flex-shrink-0" />
                  <span className="hidden xs:inline">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileCourseButtons;
